import React from "react";
import { Route } from "react-router-dom";
import ManagementRoutes from "./Management/Management.routes";

const OrganizationalRoutes = (
  <Route path="organizational/*">
    Organizational
    <Route path="*" element={<div>Not Found</div>} />
    {ManagementRoutes}
  </Route>
);

export default OrganizationalRoutes;
